import * as React from 'react';
import { useSearch } from '@elastic/react-search-ui';
import { Config } from "../../helper";

export default function OpenSearchStats() {
  const {
    totalResults,
    resultsPerPage,
    rawResponse,
  } = useSearch();

  let realTotalItems = totalResults;

  return (
    <p className='h--smaller mb-0'>{Config.I18n.Stats.FoundItems(totalResults)}</p>
  );
}
